// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2VAeQ","label":"CategoryService_label__zVSdA","location":"CategoryService_location__6jmpU"};